export default __webpack_public_path__ + "static/online-workshop-ec083421b5c051e42f37e0e38eaa5ef8.png";